import {React, useState, useEffect} from "react";
import jawLogo from "../../Images/JE-logo.jpeg"; // Put your JAW logo path here
import jawBg from "../../Images/2012.jpg";     // Put your background image path here
import { FaClock, FaCog, FaEnvelope, FaMapMarkerAlt, FaPhoneAlt, FaRegClock, FaWrench } from "react-icons/fa";
import facilityImg from '../../Images/eng-rec.jpg';
import engrec1 from '../../Images/eng-rec-1.jpg';
import engrec2 from '../../Images/eng-rec-2.jpg';
import engrec3 from '../../Images/eng-rec-3.jpg';
import engrec4 from '../../Images/eng-rec-4.jpg';
import engrec5 from '../../Images/eng-rec-5.jpg';


const stats = [
  { value: "15+", label: "Years Experience" },
  { value: "5000+", label: "Engines Serviced" },
  { value: "24hr", label: "Turnaround Time" },
];


// Data for services
const services = [
  {
    title: "CYLINDER HEAD & BLOCK MACHINING",
    description:
      "Precision machining using advanced equipment for optimal surface finish",
  },
  {
    title: "CRANKSHAFT GRINDING & BALANCING",
    description:
      "Expert grinding and dynamic balancing for smooth operation",
  },
  {
    title: "VALVE SEAT & GUIDE REPLACEMENT",
    description:
      "Complete valve train refurbishment with OEM-grade components",
  },
  {
    title: "REBORING & HONING",
    description:
      "Cylinder resizing with precise tolerances for perfect piston fit",
  },
];

// Dummy gallery images (replace with your real imports)
const galleryImages = [
  engrec1,
  engrec2,
  engrec3,
  engrec4,
  engrec5,
  engrec1,
];

const qrCodeHospet = 'https://via.placeholder.com/150';

const API_BASE_URL = (process.env.NODE_ENV === 'production' ? 'https://japl-backend-v2jm.onrender.com/api' : 'http://localhost:5000/api')
// const API_BASE_URL = 'http://localhost:5000/api'


const JAW_ENG_REC = () => {

    // State for backend QR URLs for RANE sub-branches
        const [qrHospet, setQrHospet] = useState(null);
        
          // Fetch QR for RANE Hospet and Chitradurga on mount
          useEffect(() => {
            async function fetchQRs() {
              try {
                const res1 = await fetch(`${API_BASE_URL}/branchqrcode/Engine Reconditioning::Hospet`);
                if (res1.ok) {
                  const data1 = await res1.json();
                  setQrHospet(data1.qrCodeImageURL.startsWith('http') ? data1.qrCodeImageURL : `https://japl-backend-v2jm.onrender.com/${data1.qrCodeImageURL.replace(/^\//, '')}`);
                } else {
                  setQrHospet(null);
                }
    
              } catch {
                setQrHospet(null);
              }
            }
            fetchQRs();
          }, []);
  

  return (
<main>
  <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
    {/* Background image */}
    <img
      src={engrec4}
      alt="Engine Workshop Background"
      className="absolute inset-0 w-full h-[390px] md:h-[370px] lg:h-[400px] object-cover object-center"
      style={{ zIndex: 1 }}
    />
    {/* Backdrop overlay for readability */}
    <div className="absolute inset-0 h-[390px] md:h-[370px] lg:h-[400px] bg-black/30" style={{ zIndex: 2 }} />

    {/* Content Row */}
    <div className="relative z-10 flex flex-row items-center justify-center w-full max-w-6xl px-6 pt-4">
      {/* Logo (left) */}
      <div className="hidden sm:flex items-center justify-center mr-8">
        <img
          src={jawLogo}
          alt="JAW Logo"
          className="w-32 h-32 object-contain drop-shadow-xl"
        />
      </div>
      {/* Heading Texts */}
      <div className="flex flex-col items-center sm:items-start text-white w-full">
        <h1 className="text-3xl md:text-5xl  font-bold tracking-tight leading-tight text-center sm:text-left drop-shadow-lg">
          JANATHA AUTO WORKS <br />
          ENGINE RECONDITIONING WORKS
        </h1>
        <div className="mt-4 text-lg md:text-xl font-semibold text-center sm:text-left text-white drop-shadow-sm">
          Precision. Performance. Reliability.
        </div>
      </div>
    </div>

    {/* Description below image */}
    <div className="absolute left-0 right-0 bottom-8">
      <div className="mx-auto max-w-4xl bg-white rounded-b-2xl px-6 py-8 ">
        <p className="text-center text-lg md:text-xl text-gray-500 eading-relaxed">
          Since 2008, our Engine Reconditioning Workshop in Hospet has served as a vital center
          for restoring, enhancing, and extending the life of commercial vehicle engines —
          keeping fleets running strong in demanding industries like mining, logistics, and construction.
        </p>
      </div>
    </div>
  </section>


   {/* second section */}
    <section className="max-w-7xl mx-auto px-4 py-10 flex flex-col lg:flex-row gap-4 items-start">
    {/* Left: Facility Photo */}
    <div className="flex-1">
      <img
        src={facilityImg}
        alt="Facility"
        className="rounded-xl shadow-lg w-full object-cover min-h-[320px] max-h-[380px]"
      />
    </div>
    {/* Right: Info Content */}
    <div className="flex-1 bg-white  px-6 py-6 flex flex-col justify-center">
      <div className="flex items-center gap-3 mb-3">
        <FaWrench className="text-blue-600 text-2xl" />
        <h2 className="text-2xl font-bold text-gray-900">
          STATE-OF-THE-ART FACILITY IN HOSPET
        </h2>
      </div>
      <div className="mb-4 ">
        <dl className="divide-y divide-gray-200">
          <div className="flex justify-between py-2">
            <dt className="text-gray-500">Established</dt>
            <dd className="font-semibold text-gray-900">February 1, 2008</dd>
          </div>
          <div className="flex justify-between py-2">
            <dt className="text-gray-500">Location</dt>
            <dd className="font-semibold text-gray-900">Hampi Road, Hospet</dd>
          </div>
          <div className="flex justify-between py-2">
            <dt className="text-gray-500">Specialization</dt>
            <dd className="font-semibold text-gray-900">Commercial Vehicle Engines</dd>
          </div>
          <div className="flex justify-between py-2">
            <dt className="text-gray-500">Leadership</dt>
            <dd className="font-semibold text-gray-900">Janab G. Shafiulla Sahab</dd>
          </div>
        </dl>
      </div>
      <p className="mt-4 text-gray-600 text-base leading-relaxed">
        Strategically located to meet growing regional demand, our facility handles both in-house and third-party engine refurbishments with capabilities ranging from minor overhauls to complete engine rebuilds.
      </p>
    </div>
  </section>

  {/* Third section */}
   <section className="bg-blue-50 rounded-2xl py-8 px-4 md:px-10 max-w-7xl mx-auto mt-8">
    <h2 className="text-center text-2xl md:text-3xl font-semibold text-gray-900 mb-8 flex items-center justify-center gap-3">
      <FaCog className="text-blue-600 text-2xl" />
      SERVICES OFFERED
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {services.map((s) => (
        <div
          key={s.title}
          className="bg-white shadow-md rounded-xl flex items-start gap-4 py-6 px-5 hover:shadow-xl transition"
        >
          <div className="flex items-center justify-center mt-1">
            <FaCog className="text-blue-500 text-3xl" />
          </div>
          <div>
            <div className="font-bold text-gray-900 text-base mb-1">
              {s.title}
            </div>
            <div className="text-sm text-gray-600">
              {s.description}
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>

  {/* Gallery section */}
  <section className="max-w-7xl mx-auto px-4 py-12">
    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center">
      GALLERY
    </h2>
    <div className="grid grid-cols-2 md:grid-cols-3  gap-6">
      {galleryImages.map((img, idx) => (
        <div
          key={img}
          className="rounded-xl overflow-hidden shadow hover:shadow-lg transition aspect-w-4 aspect-h-3 bg-gray-200"
        >
          <img
            src={img}
            alt={`Gallery photo ${idx + 1}`}
            className="w-full h-full object-cover"
          />
        </div>
      ))}
    </div>
  </section>

  {/* fifth section */}
   <section className="max-w-5xl mx-auto py-12 px-4 text-center">
    <div className="flex items-center justify-center gap-3 mb-5">
      <FaRegClock className="text-blue-600 text-2xl" />
      <h2 className="text-2xl md:text-2xl font-bold text-gray-900">
        TRUSTED BY FLEETS IN DEMANDING SECTORS
      </h2>
    </div>
    <p className="max-w-3xl mx-auto text-gray-600 text-base md:text-lg mb-8">
      Critical support for high-volume operations during peak mining periods. Our reconditioned
      engines power fleets across <span className="font-semibold">Karnataka&#39;s mining zones</span>.
    </p>
    <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-8">
      {stats.map((stat) => (
        <div
          key={stat.label}
          className="bg-blue-50 rounded-lg px-8 py-6 flex flex-col items-center min-w-[150px]"
        >
          <span className="text-blue-700 text-2xl font-bold mb-1">{stat.value}</span>
          <span className="text-gray-600 text-sm">{stat.label}</span>
        </div>
      ))}
    </div>
    <blockquote className="max-w-3xl mx-auto border-l-4 border-blue-400 pl-6 italic text-blue-700 text-lg font-medium">
      “We don’t make engines just run — they perform, persist, and power the backbone of heavy-duty operations.”
    </blockquote>
  </section>

  {/* last section */}
  <section className="bg-gradient-to-br from-[#222d43] to-[#243152] py-12 px-3 min-h-[540px]">
    <h2 className="text-3xl font-extrabold text-white text-center mb-2 tracking-wide">
      GET IN TOUCH
    </h2>
    <div className="border-t-2 border-blue-500 w-12 mx-auto mb-6" />
    <p className="text-center text-gray-200 mb-8 text-lg">
      We're here to help and answer any questions you might have.
    </p>

    <div className="flex flex-col lg:flex-row max-w-7xl mx-auto gap-8">
      {/* Left - Contact Information */}
      <div className="bg-[#25355b] text-white rounded-2xl shadow-lg p-6 flex-1 min-w-[320px] flex flex-col gap-3 border border-blue-900">
        <div className="flex items-center gap-2 mb-2">
          <FaMapMarkerAlt className="text-blue-500 text-xl" />
          <h3 className="text-lg font-bold">CONTACT INFORMATION</h3>
        </div>
        <div className="text-blue-300 mb-2 pl-7 text-md">Hospet Location</div>
        <div className="flex items-center gap-3 mt-3">
          <FaEnvelope className="text-blue-400 text-xl" />
          <div>
            <div className="font-bold text-base leading-tight">EMAIL US</div>
            <a
              href="mailto:jaw.hospet@gmail.com"
              className="text-blue-300 underline text-md"
            >
              jaw.hospet@gmail.com
            </a>
          </div>
        </div>
        <div className="flex items-center gap-3 mt-4">
          <FaPhoneAlt className="text-blue-400 text-xl" />
          <div>
            <div className="font-bold text-base leading-tight">CALL US</div>
            <a
              href="tel:+919986148034"
              className="text-blue-300 underline text-md"
            >
              +91 9986148034
            </a>
          </div>
        </div>
        <div className="flex items-center gap-3 mt-4">
          <FaClock className="text-blue-400 text-xl" />
          <div>
            <div className="font-bold text-base leading-tight">BUSINESS HOURS</div>
            <div className="text-blue-300 text-md">
              Monday – Saturday: 10:00 AM – 6:30 PM
            </div>
          </div>
        </div>
      </div>

      {/* Right - Location Information & QR Code */}
      <div className="bg-blue-800/90 rounded-2xl shadow-lg p-6 flex-1 min-w-[340px] flex flex-col items-center lg:items-start border border-blue-900">
        <h3 className="text-lg font-bold text-white mb-2 text-center lg:text-left">
          HOSPET LOCATION
        </h3>
        <div className="text-blue-200 text-center mb-5 text-sm">
          Scan the QR code for directions to our office
        </div>
        <div className="flex flex-col md:flex-row items-center gap-7 w-full">
         <img
              src={qrHospet || qrCodeHospet}
              alt="QR Code Hospet"
              className='w-40 h-40 rounded-lg bg-white'
            />
          <div className="bg-blue-800/90 border border-blue-500 rounded-xl p-5 w-full text-white mt-6 md:mt-0">
            <div className="mb-1 font-semibold text-blue-100 text-base">LOCATION DETAILS:</div>
            <div className="text-sm leading-snug mb-3">
              Janatha Auto Works<br />
              #10 Janatha Complex<br />
              Hampi Road, Near Bala Talkies<br />
              Hospet – 583201
            </div>
            <div className="mb-1 font-semibold text-blue-100 text-base">LANDMARKS:</div>
            <ul className="list-disc pl-5 text-sm text-blue-100 space-y-1">
              <li>Opposite to Hospet Bus Stand</li>
              <li>Near Vijaya Bank</li>
              <li>100m from Bala Talkies Cinema</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  </main>
);
}
export default JAW_ENG_REC;
